// extracted by mini-css-extract-plugin
export default {"checkboxInput":"Input_checkboxInput__ZlxTK","checkbox":"Input_checkbox__ec1WS","checkboxIcon":"Input_checkboxIcon__Z6Xsi","checked":"Input_checked__e+y+j"};